import { render, staticRenderFns } from "./relayDetailWin.vue?vue&type=template&id=5e27fb16&scoped=true&"
import script from "./relayDetailWin.vue?vue&type=script&lang=js&"
export * from "./relayDetailWin.vue?vue&type=script&lang=js&"
import style0 from "./relayDetailWin.vue?vue&type=style&index=0&id=5e27fb16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e27fb16",
  null
  
)

export default component.exports